import React from 'react';
import { Page } from '../Page';
import { SupplementCallout } from '../SupplementCallout';
import { Moon, Activity, Brain, Battery } from 'lucide-react';
export function PageSleep() {
  return <Page pageNumber={29} variant="light" data-id="element-1592" data-mp="1lx0ka7ja7von">
      <div className="flex h-full gap-12" data-id="element-1593" data-mp="1lvyxx6wtfmrm">
        {/* Left 1/3 Column */}
        <div className="w-1/3 flex flex-col" data-id="element-1594" data-mp="1qxo7sj8axue4">
          <div className="h-[260px] w-full mb-6 overflow-hidden" data-id="element-1595" data-mp="1qu8rxe6t0hbn">
            <img src="https://images.unsplash.com/photo-1531353826977-0941b4779a1c?w=800&q=80" alt="Peaceful bedroom" className="w-full h-full object-cover" data-id="element-1596" data-mp="1vuwpkipjfweu" />
          </div>

          <div className="bg-[#EAEAE4] border border-[#D8D8D0] p-6 text-center mb-8" data-id="element-1597" data-mp="25nlzva9cr48l">
            <h2 className="text-[10px] font-bold text-tealslate uppercase tracking-[0.2em] mb-2" data-id="element-1598" data-mp="29mbaiv30a7oj">
              Daily Target
            </h2>
            <p className="text-3xl font-serif text-[#1F1F1F]" data-id="element-1599" data-mp="2jkr4r6xbxx29">7-9 hours</p>
            <p className="text-xs text-[#7A7A70] mt-1" data-id="element-1600" data-mp="2jixttffooqog">per night</p>
          </div>

          <div className="border-t border-[#D8D8D0] pt-6" data-id="element-1601" data-mp="yubqcf8yl6dy">
            <h3 className="font-bold text-[#1F1F1F] text-xs mb-3" data-id="element-1602" data-mp="twa7nvfg3930">
              Practical Tips
            </h3>
            <ul className="space-y-3 text-[11px] text-[#7A7A70] leading-[1.6]" data-id="element-1603" data-mp="pwjb1b38lyqk">
              <li className="flex gap-2" data-id="element-1604" data-mp="kxez4coxhmwj">
                <span className="text-tealslate" data-id="element-1605" data-mp="kyq6emhl1cse">•</span>
                Maintain a consistent bedtime and wake time
              </li>
              <li className="flex gap-2" data-id="element-1606" data-mp="1dlkkn1nt3fxf">
                <span className="text-tealslate" data-id="element-1607" data-mp="1dlug34rmefai">•</span>
                Keep your bedroom dark, quiet, and cool (65-68°F)
              </li>
              <li className="flex gap-2" data-id="element-1608" data-mp="13vixcc3a21jk">
                <span className="text-tealslate" data-id="element-1609" data-mp="13ug62321lx34">•</span>
                Limit screen time 1 hour before bed
              </li>
              <li className="flex gap-2" data-id="element-1610" data-mp="21c7ye3kekzrw">
                <span className="text-tealslate" data-id="element-1611" data-mp="1wjn6j7l24wr0">•</span>
                Avoid caffeine after 2:00 PM
              </li>
            </ul>
          </div>
        </div>

        {/* Right 2/3 Column */}
        <div className="w-2/3 flex flex-col" data-id="element-1612" data-mp="2kf8mt59qba67">
          <div className="mb-8 pt-4" data-id="element-1613" data-mp="2kf0dtogq8p0a">
            <p className="text-[10px] font-bold text-tealslate uppercase tracking-[0.2em] mb-3" data-id="element-1614" data-mp="26o3ktwiw25sp">
              The Essentials
            </p>
            <h1 className="text-5xl font-serif text-[#1F1F1F] leading-tight mb-4" data-id="element-1615" data-mp="2aoe2i6g1mkne">
              Prioritizing <span className="text-tealslate" data-id="element-1616" data-mp="1wowbrlj6sxbe">Sleep</span>
            </h1>
            <div className="w-16 h-0.5 bg-tealslate" data-id="element-1617" data-mp="21pjz9x87iw0v" />
          </div>

          <p className="text-sm text-[#3B3B3B] leading-[1.8] mb-10" data-id="element-1618" data-mp="21mo1qa09u9cy">
            Poor sleep increases cortisol, which increases insulin resistance,
            which makes weight loss harder. It also increases cravings for sugar
            and carbohydrates the next day.
          </p>

          <h2 className="text-xl font-serif text-[#1F1F1F] mb-6" data-id="element-1619" data-mp="3i160mpd5yrbt">
            Why It Matters for GLP-1
          </h2>

          <div className="grid grid-cols-2 gap-4 mb-10" data-id="element-1620" data-mp="1ahif0b0onyx8">
            <div className="bg-[#EAEAE4] border border-[#D8D8D0] p-5" data-id="element-1621" data-mp="1ai1vdnaoqf95">
              <Brain className="w-6 h-6 text-tealslate mb-3" data-id="element-1622" data-mp="16gq5rhrt9u0y" />
              <h3 className="font-bold text-[#1F1F1F] text-xs mb-1" data-id="element-1623" data-mp="1k7bon6h9m3yu">
                Hormone Balance
              </h3>
              <p className="text-[10px] text-[#7A7A70] leading-[1.6]" data-id="element-1624" data-mp="1fg3g0cnremmq">
                Poor sleep increases ghrelin (hunger) and reduces leptin
                (satiety).
              </p>
            </div>
            <div className="bg-[#EAEAE4] border border-[#D8D8D0] p-5" data-id="element-1625" data-mp="1p6y5rr07s4cx">
              <Activity className="w-6 h-6 text-tealslate mb-3" data-id="element-1626" data-mp="2367hoehe0cb3" />
              <h3 className="font-bold text-[#1F1F1F] text-xs mb-1" data-id="element-1627" data-mp="235o234f7m008">
                Insulin Sensitivity
              </h3>
              <p className="text-[10px] text-[#7A7A70] leading-[1.6]" data-id="element-1628" data-mp="1y5a3eczi02ev">
                Sleep deprivation impairs how your body handles blood sugar.
              </p>
            </div>
            <div className="bg-[#EAEAE4] border border-[#D8D8D0] p-5" data-id="element-1629" data-mp="3uwpw3z8ovif">
              <Battery className="w-6 h-6 text-tealslate mb-3" data-id="element-1630" data-mp="66yswmeo5rxy" />
              <h3 className="font-bold text-[#1F1F1F] text-xs mb-1" data-id="element-1631" data-mp="a927vl0jrenz">
                Muscle Recovery
              </h3>
              <p className="text-[10px] text-[#7A7A70] leading-[1.6]" data-id="element-1632" data-mp="f85a6xp576s9">
                Most muscle repair happens during deep sleep phases.
              </p>
            </div>
            <div className="bg-[#EAEAE4] border border-[#D8D8D0] p-5" data-id="element-1633" data-mp="3ipf89m439olp">
              <Moon className="w-6 h-6 text-tealslate mb-3" data-id="element-1634" data-mp="3in2hqkk9m5x1" />
              <h3 className="font-bold text-[#1F1F1F] text-xs mb-1" data-id="element-1635" data-mp="3np061t7ivqwu">
                Energy Levels
              </h3>
              <p className="text-[10px] text-[#7A7A70] leading-[1.6]" data-id="element-1636" data-mp="3slqi85g7i2cz">
                Combats the fatigue often associated with calorie deficits.
              </p>
            </div>
          </div>

          <div className="mt-auto" data-id="element-1637" data-mp="2zy4fezesz1r6">
            <SupplementCallout title="Sleep Support" description="Melatonin (0.5-3mg) for sleep onset and magnesium glycinate (200-400mg) for sleep quality are both well-researched options. Take 30-60 minutes before bed." data-id="element-1638" data-mp="34xquzfi3su35" />
          </div>
        </div>
      </div>
    </Page>;
}